// originally from:
// https://github.com/drozhzhin-n-e/ng2-tooltip-directive

import { Component,
         ElementRef,
         HostListener,
         HostBinding,
         Input,
         OnInit,
         EventEmitter, 
         OnChanges,
         OnDestroy,
         SimpleChanges} from '@angular/core'
import { LcpHelper } from '../../_core/_helpers/lcp-helper'
import { AppStatic } from '../../_core/_helpers/app-static'

@Component({
  selector: 'lcp-media',
  templateUrl: 'media.component.html',
  styleUrls: ['media.component.scss'],
  host: {'class': 'lcp-media'},
})

export class MediaComponent implements OnInit, OnChanges, OnDestroy {

  @Input() media: any
  @Input() klass: any

  constructor(
    protected lcpHelper: LcpHelper,
    private el: ElementRef
  ) {}

  events = new EventEmitter()
  tags: string[]
  mouseMoveListener: any

  ngOnInit(): void {
    this.tags = this.media?.metadata?.tags?.map(tag => tag?.sys?.id)
  }

  ngAfterViewInit(): void {
    if (this.klass &&this.el.nativeElement) {
      this.klass.split(" ").forEach(k => this.el.nativeElement.classList.add(k))
    }
    this.autoplayVideo()
  }

  autoplayVideo() {
    if (!AppStatic.isBrowser) return
    const video = this.el.nativeElement.querySelector('video')
    if (video) {
      video.muted = true
      video.setAttribute('muted', 'true')
      video.play().then(() => {
        console.log('video played', video.currentSrc.split('/').pop())
      }).catch((err) => {
        console.log('video play error', err)
        this.mouseMoveListener = document.addEventListener('mousemove', () => video.play(), { once: true });
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('media-chg', changes)
  }

  ngOnDestroy(): void {
    this.mouseMoveListener && document.removeEventListener('mousemove', this.mouseMoveListener)
  }

  detectChanges() {
    
  }
}
